import { Inbox } from "lucide-react";

export default function EmptyState({ title, description, action, icon: Icon = Inbox, testId }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-md border border-dashed border-slate-200 bg-white py-16 px-6 text-center" data-testid={testId}>
      <Icon size={36} className="gp-empty-icon mb-3" />
      <h3 className="text-slate-700 text-base font-medium">{title}</h3>
      {description && <p className="mt-1 text-sm text-slate-500 max-w-md">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
